module.exports = require('./helpers/bundle-url').getBundleURL('d4fau') + "logo-dark.ba5147f0.svg";